import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import CharactersScreen from './src/screens/CharactersScreen';
import PlanetsScreen from './src/screens/PlanetsScreen';
import CharacterDetailScreen from './src/screens/CharacterDetailScreen';
import PlanetDetailScreen from './src/screens/PlanetDetailScreen';

const Tab = createBottomTabNavigator();
const Stack = createStackNavigator();

const CharactersStack = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen 
        name="CharactersList" 
        component={CharactersScreen}
        options={{ 
          title: 'Characters',
          headerStyle: {
            backgroundColor: '#f4511e',
          },
          headerTintColor: '#fff',
        }}
      />
      <Stack.Screen 
        name="CharacterDetail" 
        component={CharacterDetailScreen}
        options={({ route }) => ({ 
          title: route.params.character.name,
          headerStyle: {
            backgroundColor: '#f4511e',
          },
          headerTintColor: '#fff',
        })}
      />
    </Stack.Navigator>
  );
};

const PlanetsStack = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen 
        name="PlanetsList" 
        component={PlanetsScreen}
        options={{ 
          title: 'Planets',
          headerStyle: {
            backgroundColor: '#f4511e',
          },
          headerTintColor: '#fff',
        }}
      />
      <Stack.Screen 
        name="PlanetDetail" 
        component={PlanetDetailScreen}
        options={({ route }) => ({ 
          title: route.params.planet.name,
          headerStyle: {
            backgroundColor: '#f4511e',
          },
          headerTintColor: '#fff',
        })}
      />
    </Stack.Navigator>
  );
};

export default function App() {
  return (
    <NavigationContainer>
      <Tab.Navigator
        screenOptions={{
          tabBarActiveTintColor: '#f4511e',
          tabBarInactiveTintColor: 'gray',
          headerStyle: {
            backgroundColor: '#f4511e',
          },
          headerTintColor: '#fff',
        }}
      >
        <Tab.Screen
          name="Characters"
          component={CharactersStack}
          options={{
            headerShown: false,
            tabBarIcon: ({ color, size }) => (
              <MaterialCommunityIcons name="account-group" color={color} size={size} />
            ),
          }}
        />
        <Tab.Screen
          name="Planets"
          component={PlanetsStack}
          options={{
            headerShown: false,
            tabBarIcon: ({ color, size }) => (
              <MaterialCommunityIcons name="earth" color={color} size={size} />
            ),
          }}
        />
      </Tab.Navigator>
    </NavigationContainer>
  );
}